import React from "react";
import ReactApexChart from "react-apexcharts";
import { scatterChartData } from "../MockData";
import { reviveFunctions } from "../../../slices/layouts/utils";

function ScatterChart({  data_set }) {

  console.log(data_set, "Scatter plot Data")
  let { series , chart , xaxis , yaxis } = data_set
  let options = { series , chart , xaxis , yaxis }

  options = reviveFunctions(options)

  console.log("Scatter plot", options)

  return (
    <ReactApexChart
      options={options}
      series={options.series}
      type="scatter"

    />
  );
}

export default ScatterChart;
